import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { BgpNeighbor } from "./BgpData";

export function makeBgpNeighborFields(): FilterField<BgpNeighbor>[] {
  const fields: FilterField<BgpNeighbor>[] = [
    {
      label: "Neighbor IP",
      key: "neighborip",
      accessor: (r) => r.ipid,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Local Address",
      key: "localaddress",
      accessor: (r) => r.local_address || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Local AS",
      key: "localas",
      accessor: (r) => (r.local_as ?? "").toString(),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Peer AS",
      key: "peeras",
      accessor: (r) => (r.peer_as ?? "").toString(),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Router ID",
      key: "routerid",
      accessor: (r) => r.router_id,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Description",
      key: "description",
      accessor: (r) => r.description || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "BGP Family",
      key: "bgpfamily",
      accessor: (r) => r.bgpfamily || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Hold Time",
      key: "holdtime",
      accessor: (r) => (r.holdtime ?? "").toString(),
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

